import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  GetRunLogsResponse,
  RunLogParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  children?: (data: GetRunLogsResponse) => ReactElement
  onSuccess?: (data: GetRunLogsResponse) => void
  params?: RunLogParams
}

const buildUrl = (baseUrl: string, params?: RunLogParams) => {
  if (!params) return baseUrl

  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined) return

    Array.isArray(value)
      ? value.forEach(item => searchParams.append(key, String(item)))
      : searchParams.append(key, String(value))
  })

  const queryString = searchParams.toString()

  return queryString
    ? `${baseUrl}?${queryString}`
    : baseUrl
}

const GetAiRunLogRequest = ({
  id,
  children,
  onSuccess,
  params
}: Props) => {
  const url = buildUrl(`${AI_API_SERVICE}/runlogs/${id}`, params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetAiRunLogRequest
